import request from '@/service'

export const switchMum = ({ commit }, payload) => {
  commit('switchMum', payload)
}

export const playMsg = ({ commit }, payload) => {
  commit('playMsg', payload)
}

export const setPopalories = ({ commit }, payload) => {
  commit('setPopalories', payload)
}

/**
 * 获取用户信息
 */
export const getUserInfo = ({ commit }, params) => {
  request.get('user/info').then((res) => {
    commit('setUserInfo', res)
    params && params.fun && params.fun(res)
  })
}

/**
 */
export const userLuck = ({ commit }, params) => {
  request.get('user/lot').then((res) => {
    commit('setUserInfo', res)
    params.fun && params.fun(res)
  })
}

// 获取组别
export const getGroup = ({ commit }, params) => {
  request.get('user/group').then((res) => {
    commit('setGroup', res)
  })
}

// 提交表单信息
export const submitFun = ({ commit }, params) => {
  request.post('user/signup', params).then((res) => {
    commit('setUserInfo', res)
    params && params.fun && params.fun(res)
  })
}

// 查询身份证信息
export const codeSubmitFun = ({ commit }, params) => {
  request.post('user/query', params).then((res) => {
    params && params.fun && params.fun(res)
  })
}

export const shareSee = ({ commit }, params) => {
  request.get('user/medal').then((res) => {
    commit('setUserInfo', res)
  })
}

export const seePop = ({ commit }, params) => {
  request.get('user/pop').then((res) => {
    commit('setUserInfo', res)
  })
}

// 分享
export const shareFun = ({ commit }, params) => {
  request.get('user/share').then((res) => {
    commit('setUserInfo', res)
  })
}
